export default ({axios, mapQueryString, withoutInvalidValues}) => ({
    list: (query = {}) => axios.get(`/referrals${mapQueryString(withoutInvalidValues(query))}`),
    overview: (query = {}) => axios.get(`/referral-rewards/overview${mapQueryString(query)}`),
    revoke: (id) => axios.post(`/referral-rewards/${id}/revoke`),
    codes: (query = {}) => axios.get(`/referral-codes${mapQueryString(query)}`),
    create: (body = {}) => axios.post(`/referral-codes`, body),
    update: (id, body = {}) => axios.patch(`/referral-codes/${id}`, body)
})
